import { getGame } from "@/games";
import { getImgproxyUrl } from "@/lib/imgproxy";
import { SupportedGames } from "@/types/game";
import { CDN } from "@/lib/cdn";

/**
 * Get the leader square image URL for a specific game
 * @param id - The leader card ID (e.g., "OP01-001" for One Piece, "N-001" for Naruto)
 * @param gameName - The game identifier (defaults to "one-piece" for backward compatibility)
 * @param size - Optional box to resize to via imgproxy. Leader squares have no
 *   pre-generated size variants on the CDN, so without this the full-resolution
 *   asset is served and scaled down by the browser.
 * @returns The image URL, routed through the backend's imgproxy endpoint
 */
export function getLeaderSquare(
  id: string,
  gameName: SupportedGames = "one-piece",
  size?: { width?: number; height?: number },
): string {
  const game = getGame(gameName);
  const leaderSquaresPath = game.cdn?.leaderSquaresPath;

  // Fall back to this game's own folder. Defaulting to One Piece here silently
  // served the wrong game's art to anything that omitted leaderSquaresPath.
  const source = leaderSquaresPath
    ? `${leaderSquaresPath}/${id}.webp`
    : `${CDN}/games/${gameName}/images/leader-squares/${id}.webp`;

  // Re-encoding through imgproxy is worthwhile even with no resize — these are
  // full-size source assets.
  return getImgproxyUrl(source, size);
}
